import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/organizations").then((module) => ({
    default: module.Organizations,
  })),
);

export const Route = createFileRoute("/admin/organizations/")({
  component: Page,
});
